import { cx, variantClass } from '@/components/ui/styles';

const brandMarkSizes = {
  large: 'h-16',
  small: 'h-8'
} as const;

interface BrandMarkProps {
  size?: keyof typeof brandMarkSizes;
}

// The supplied artwork is outlined so its lettering never depends on local fonts.
export function BrandMark({ size = 'small' }: BrandMarkProps) {
  return (
    <svg
      aria-hidden
      focusable="false"
      className={cx(
        'block w-auto shrink-0 fill-current text-text',
        variantClass(brandMarkSizes, size)
      )}
      viewBox="0 0 101 52"
    >
      <use href="/sml.svg#sml-logo" />
    </svg>
  );
}
